<template>
    <div>
        <template>
            <div class="manage--main">
                <div class="header-manage">
                    <div class="user-name" id="clm" v-if="mobile && !menu">
                        <template v-if="courseName != null && courseName.search('@') !== -1">{{courseName}}</template>
                        <template v-if="courseName != null && courseName.search('@') == -1">{{courseName}}</template>
                    </div>
                    <div class="user-namesss" v-if="mobile && menu">
                        <template v-if="courseName != null && courseName.search('@') !== -1">{{courseName}}</template>
                        <template v-if="courseName != null && courseName.search('@') == -1">{{courseName}}</template>
                    </div>
                    <div class="icon-img-right" @click="showUser()">
                        <template v-if="menu"><img src="../../../static/images/icon-cb-trang.png" /></template>
                        <template v-else><img src="../../../static/images/mucluc-trang.png" /></template>
                    </div>
                </div>
                <!-- left -->
                <left :data="{dataGeneral: dataGeneral}" v-on:changeItem="changeItem($event)"></left>
                <!-- main -->
                <contentManage :data="{data: dataContent}"></contentManage>
            </div>
        </template>
    </div>
</template>

<script>
    import left from "@/components/faq/left_faq";
    import contentManage from "@/components/faq/content_faq";

    export default {
        data() {
            return {
                dataGeneral: [
                    // Chinese
                    {
                        environment: 1,
                        dataList: [
                            {
                                id: 0,
                                name: "Study-artsにログインする方法は？"
                            },
                            {
                                id: 1,
                                name: "パスワードを忘れた場合の対処方法？"
                            },
                            {
                                id: 2,
                                name: "電話での使用方法？"
                            },
                        ]
                    },
                    // English
                    {
                        environment: 2,
                        dataList: [
                            {
                                id: 0,
                                name: "Study-artsにログインする方法は？"
                            },
                            {
                                id: 1,
                                name: "パスワードを忘れた場合の対処方法？"
                            },
                            {
                                id: 2,
                                name: "電話での使用方法？"
                            },
                        ]
                    },
                    // Japan
                    {
                        environment: 3,
                        dataList: [
                            {
                                id: 0,
                                name: "Study-artsにログインする方法は？"
                            },
                            {
                                id: 1,
                                name: "パスワードを忘れた場合の対処方法？"
                            },
                            {
                                id: 2,
                                name: "電話での使用方法？"
                            }
                        ]
                    },
                    // Vietnamese
                    {
                        environment: 4,
                        dataList: [
                            {
                                id: 0,
                                name: "Làm sao để login vào hệ thống ?"
                            },
                            {
                                id: 1,
                                name: "Làm gì khi quên mật khẩu ?"
                            },
                            {
                                id: 2,
                                name: "Làm sao để sử dụng trên điện thoại ?"
                            },
                            {
                                id: 3,
                                name: "Làm sao để xem khóa học của tôi ?"
                            }
                        ]
                    },
                ],
                courseName: this.$t("home.faq"),
                menu: true,
                dataContent: {},
            };
        },
        components: {
            left,
            contentManage,
        },
        mounted() {
            if (this.checkMobile()) {
                this.dataContent.id = 0;
                document.getElementsByTagName("body")[this.$CONST.COMMON.NUMBER.ZERO].classList.toggle("show-menu-1");
            }
        },
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        methods: {
            changeItem: function (params) {
                this.menu = !this.menu;
                this.dataContent = params;
                this.courseName = params.name;
            },
            showUser: function () {
                this.menu = !this.menu;
                document.getElementsByTagName("body")[this.$CONST.COMMON.NUMBER.ZERO].classList.toggle("show-menu-1");
            },
        },
    };
</script>
<style scoped>
    .exam_btn.btn-login.disable {
        background: #d2d2d2 !important;
        cursor: no-drop;
    }
    .primarylists {
        margin-top: 15px;
        margin-left: 15px;
    }
    .nameStudent {
        color: #da251d;
    }
    .user-name {
        margin-left: 4px;
    }
    .user-name.ml {
        margin-left: 50px;
    }
    .user-namesss {
        font-weight: bold;
        padding: 0 5px;
        text-transform: uppercase;
        font-size: 18px;
        color: #fff;
        margin-left: 4px;
        text-overflow: ellipsis !important;
        overflow: hidden;
        white-space: nowrap;
    }
    .title-flex {
        display: flex;
        align-items: center;
    }
    .new-btn {
        margin: 0 0px 0 10px !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/index/faq_new.vue